import { Popup } from 't-lib-ui/structure';
import FeedIssueIcon from './FeedIssueIcon';
import { formatLastPostTime } from '../utils/formatting';
import './FeedIssuePopup.css';

interface FeedIssuePopupProps {
  show: boolean;
  /** Number of consecutive failed fetches. */
  fetchErrorCount?: number;
  /** Server-time when the current run of failures began (ISO 8601 string). */
  fetchFailingSinceAt?: string;
  /** Feed title, shown in the explanation. */
  feedTitle?: string;
  onClose: () => void;
  closeFocus?: string;
}

const FeedIssuePopup: React.FC<FeedIssuePopupProps> = ({ show, fetchErrorCount, fetchFailingSinceAt, feedTitle, onClose, closeFocus }) => {
  const count = fetchErrorCount ?? 0;
  const since = fetchFailingSinceAt ? formatLastPostTime(fetchFailingSinceAt) : '';
  return (
    <Popup show={show} title="Feed problem" onClose={onClose} closable minWidth="320px" closeFocus={closeFocus} className="feedIssuePopup">
      <div className="feedIssueInfo">
        <div className="feedIssueInfoIcon"><FeedIssueIcon size={26} color="var(--error-color)" /></div>
        <p className="feedIssueLede">
          We couldn't fetch new posts{feedTitle ? <> for <strong>{feedTitle}</strong></> : null}. This usually
          means the site is down or its feed address has changed.
        </p>
        {count > 0 && (
          <p className="feedIssueDetail">
            It has failed <strong>{count}</strong> time{count == 1 ? '' : 's'} in a row{since ? <>, starting <strong>{since}</strong></> : null}.
          </p>
        )}
        <p className="feedIssueHint">
          We'll keep retrying automatically. If it stays broken, the site may have stopped
          publishing this feed. You can unfollow it if you no longer need it.
        </p>
      </div>
    </Popup>
  );
};

export default FeedIssuePopup;
